import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AmountPipe } from '../../pipes/amount.pipe';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIcon,
    MatButton,
    AmountPipe
  ],
  selector: 'equine-ui-nx-cart-totals',
  templateUrl: './cart-totals.component.html',
  styleUrls: ['./cart-totals.component.scss']
})
export class CartTotalsComponent implements OnChanges {

  @Input() subtotal = 0;
  @Input() subtotalCount = 0;
  @Input() coupon = 0;
  @Input() donation = 0;
  @Input() total = 0;

  @Output() checkout = new EventEmitter<void>();

  displayedColumns: string[] = ['description', 'cost'];

  summary: {item: string, cost: number}[] = [];
  canApplyCoupon = false;

  constructor(
    private readonly router: Router
  ){ }

  ngOnChanges() {
    this.summary = [
      {item: `Order Subtotal (${this.subtotalCount} Items)`, cost: this.subtotal},
      {item: 'Coupon Codes Discounts', cost: this.coupon},
      {item: 'Donation', cost: this.donation},
    ];

    if (this.total === 0 && this.coupon > 0) {
      this.canApplyCoupon = true;
    } else {
      this.canApplyCoupon = false;
    }
  }

  proceedToCheckout() {
    this.checkout.emit();
  }

  checkoutLater() {
    this.router.navigate(['dashboard']);
  }
}
